// src/lib/graphql/fragments/cart.ts
export const CART_FIELDS = `#graphql
fragment CartFields on Cart {
  id
  checkoutUrl
  totalQuantity
  cost { subtotalAmount { amount currencyCode } }
  lines(first: 100) {
    edges {
      node {
        id
        quantity
        merchandise {
          ... on ProductVariant {
            id
            title
            price { amount currencyCode }
            image { url altText }
            product { title handle }
            availabilityTier: metafield(namespace: "custom", key: "availability_tier") { value }
          }
        }
      }
    }
  }
}
`;
